import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    title: 'Crown Wash',
    loadComponent: () =>
      import('src/app/page/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'about',
    title: 'Crown Wash - About',
    loadComponent: () =>
      import('src/app/page/about/about.component').then((m) => m.AboutComponent),
  },
  {
    path: 'contact',
    title: 'Crown Wash - Contact Us',
    loadComponent: () =>
      import('src/app/page/contact/contact.component').then((m) => m.ContactComponent),
  },
  {
    path: 'terms',
    title: 'Crown Wash - Terms of Use',
    loadComponent: () =>
      import('src/app/page/terms/terms.component').then((m) => m.TermsComponent),
  },
  {
    path: 'privacy',
    title: 'Crown Wash - Privacy Policy',
    loadComponent: () =>
      import('src/app/page/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: '**',
    title: 'Not Found',
    loadComponent: () =>
      import('src/app/page/error/error.component').then((m) => m.ErrorComponent),
  },
];
